'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _queries = require('./queries.html');

var _queries2 = _interopRequireDefault(_queries);

var _queries3 = require('./queries.controller');

var _queries4 = _interopRequireDefault(_queries3);

require('./queries.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var queriesComponent = {
  restrict: 'E',
  bindings: {},
  template: _queries2.default,
  controller: _queries4.default,
  controllerAs: 'vm'
};

exports.default = queriesComponent;


// WEBPACK FOOTER //
// ./client/app/common/reports/queries/queries.component.js